/**
 * Techo de espera para una descarga por GET (típicamente un Excel armado en el
 * servidor). Pasado ese tiempo el frontend desiste y desuscribe, lo que aborta
 * el `fetch` y le avisa al backend que puede soltar el trabajo.
 *
 * Cinco minutos es un límite deliberadamente generoso: los exports completos
 * medidos rondan el minuto, así que sólo dispara cuando algo se colgó de
 * verdad. El techo del servidor tiene que estar alineado con este valor (ver
 * `timeoutMs` del proxy del gateway).
 */
export const DOWNLOAD_TIMEOUT_MS = 5 * 60 * 1000;
